export default __webpack_public_path__ + "static/media/1964.2651da43.png";